var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 丟失保價： "),_c('div',[_vm._v(" 未透過淘寶/阿里巴巴導入訂單金額的手動登記包裹目前不提供免費丟失保價，僅有自行使用淘寶/阿里巴巴導入訂單金額的包裹可享有免費丟失保價。"),_c('br'),_vm._v(" 如手動登記包裹需要丟失保價，可以在下單時自行加購，保費為商品價值的1%，1元台幣=100元台幣的保價，詳細保價規則可以在下單時查看《丟失保價服務協議》。 ")])])
}]

export { render, staticRenderFns }